(ns frontend.test.selection-pill.view
  "The test page of the selection pill of a listing. It has a container that is
   like the content of a listing, a counter of selected rows, and sample actions.
   Compare it with the pill of the Dealflow page of the UX mockup."
  (:require
   [reagent.core :as r]
   [ui.components.selection-pill.view :as selection-pill]))

(defonce state*
  (r/atom {:count   2
           :clicked nil}))

(defn- control-button
  [{:keys [label on-click]}]
  [:button
   {:type     "button"
    :class    "tw2-rounded-full tw2-border tw2-border-slate-300 tw2-bg-white tw2-px-4 tw2-py-2 tw2-text-sm tw2-font-medium tw2-text-slate-700"
    :on-click on-click}
   label])

(defn view
  []
  (let [{:keys [count clicked]} @state*]
    [:div {:class "tw2 tw2-min-h-screen tw2-bg-white tw2-p-8"}
     [:div {:class "tw2-mx-auto tw2-max-w-[1200px] tw2-space-y-6"}
      [:h1 {:class "tw2-text-3xl tw2-font-semibold tw2-text-slate-950"}
       "Selection Pill Playground"]
      [:p {:class "tw2-max-w-3xl tw2-text-sm tw2-text-slate-600"}
       "The selection pill of the UX mockup, with the ghost buttons of ZapKit. The pill is at the bottom of the box. It is not there when no row is selected. Drag the grip on the left of the pill, or focus it and use the arrow keys, to move the pill inside the box. Double click the grip, or press Home, to put the pill back."]
      [:div {:class "tw2-flex tw2-flex-wrap tw2-items-center tw2-gap-3"}
       [control-button
        {:label    "Select one more row"
         :on-click (fn [_]
                     (swap! state* update :count inc))}]
       [control-button
        {:label    "Select one less"
         :on-click (fn [_]
                     (swap! state* update :count (fn [n] (max 0 (dec n)))))}]
       [:span {:class "tw2-text-sm tw2-text-slate-600"}
        (str "Selected: " count ". Last action: " (or clicked "none"))]]
      [:div {:class "tw2-relative tw2-h-[360px] tw2-overflow-hidden tw2-rounded-lg tw2-border tw2-border-slate-200 tw2-bg-slate-50"}
       [:div {:class "tw2-p-4 tw2-text-sm tw2-text-slate-500"}
        "The content of a listing is here. The pill is over its bottom edge."]
       [selection-pill/view
        {:count       count
         :count-label (str count " selected")
         :actions     [{:id       :bulk-edit
                        :label    "Bulk edit"
                        :icon     :pencil
                        :on-click (fn [_]
                                    (swap! state* assoc :clicked "Bulk edit"))}
                       {:id       :bulk-delete
                        :label    "Delete"
                        :icon     :trash
                        :on-click (fn [_]
                                    (swap! state* assoc :clicked "Delete"))}
                       {:id        :disabled
                        :label     "A disabled action"
                        :disabled? true}]
         :clear-label "Clear selection"
         :move-label  "Move the selection bar"
         :on-clear    (fn [_]
                        (swap! state* assoc :count 0 :clicked "Clear selection"))}]]]]))
